import { render } from "./Development.vue?vue&type=template&id=fae789bc&ts=true&lang=pug"
import script from "./Development.vue?vue&type=script&lang=ts"
export * from "./Development.vue?vue&type=script&lang=ts"

import "./Development.vue?vue&type=style&index=0&id=fae789bc&lang=css"

import exportComponent from "/Users/lauriel/gitRepos_work/hero/hero_web_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__